import moment from "moment";

const APP_REVIEW_COLLECTION = "talmidsdb/lessonFeedBackForms";
const DEFAULT_REVIEW_COLLECTION = "talmidsdb/reviews";

export function normalizeReviewRecord(item = {}) {
	return {
		...item,
		id: item.id || item.reviewID || "",
		reviewID: item.reviewID || item.id || "",
		lessonID: item.lessonID || item.lessonId || "",
		communityID: item.communityID || item.communityId || "",
		userID: item.userID || item.userId || item.targetUserID || item.createdBy || "",
		comment: item.comment || item.reviewContent || "",
		timeStamp: item.timeStamp || item.createdAt || item.dateTime || "",
		_sourceCollection: item._sourceCollection || DEFAULT_REVIEW_COLLECTION,
	};
}

export function getReviewEndpoint(item = {}) {
	return String(item._sourceCollection || DEFAULT_REVIEW_COLLECTION)
		.replace(/^\/+/, "")
		.replace(/^talmidsdb\//, "");
}

export function formatReviewTimestamp(value) {
	if (value === null || value === undefined || value === "") return "-";
	const numericValue = typeof value === "number" ? value : /^\d{10,}$/.test(String(value)) ? Number(value) : null;
	const parsed = numericValue !== null ? moment(numericValue) : moment(value);
	return parsed.isValid() ? parsed.format("DD/MMM/YYYY HH:mm") : "-";
}

export function isReviewRecord(item = {}) {
	return item.rating !== undefined && item.rating !== null && item.rating !== "";
}

export function buildLessonReviewAverages(lessons = [], reviews = []) {
	return lessons.map((lesson) => {
		const lessonId = lesson.id || lesson.lessonID || lesson.ID;
		const ratings = reviews
			.filter((review) => review.lessonID === lessonId)
			.map((review) => Number(review.rating))
			.filter(Number.isFinite);
		if (!ratings.length) return null;
		const average = ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length;
		return {
			LessonName: lesson.lessonName || lesson.lesson || "Unknown lesson",
			LessonID: lessonId,
			AverageRating: Math.round(average * 10) / 10,
			Reviewers: ratings.length,
		};
	}).filter(Boolean);
}

export { APP_REVIEW_COLLECTION };
